import m from "./PhoneNumber.mjs";
function i(e, r, f) {
  if (r[e])
    return new m(e, r[e], f);
}
export {
  i as default
};
//# sourceMappingURL=getExampleNumber2.mjs.map
